import { useGeneralAgentChatStore } from '../hooks/generalAgentChatStore'
import { GeneralAgentChat } from './GeneralAgentChat'
import { GeneralAgentHistory } from './GeneralAgentHistory'

/** The conversation or the history list, as the shared view says; the panel and the page both render it. */
export const GeneralAgentBody = () => {
    const view = useGeneralAgentChatStore((s) => s.view)
    return view === 'history' ? <GeneralAgentHistory /> : <GeneralAgentChat />
}
